import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import GamesListPage from './pages/games/list/GamesListPage';
import ImprovHistoryPage from './pages/improv-history/ImprovHistoryPage';
import 'antd/dist/reset.css';
import './App.css';
import './../src/common/i18n/i18n';
import PresentationGame from './pages/games/presentation/PresentationGamePage';
import InterviewGamePage from './pages/games/interview/InterviewGamePage';
import InterestingDiscussionGamePage from './pages/games/interestingDiscussion/InterestingDiscussionGamePage';
import ConductedStoryGamePage from './pages/games/conductedStory/ConductedStoryGamePage';
import LinesGamePage from "./pages/games/lines/LinesGamePage";
import LineSubmitPage from "./pages/games/lines/LineSubmitPage";
import LinesAdminPage from "./pages/games/lines/LinesAdminPage";
import QuestionsGamePage from "./pages/games/questions/QuestionsGamePage";
import ConfessionGamePage from "./pages/games/confessions/ConfessionGamePage";
import OneVoiceGamePage from "./pages/games/oneVoice/OneVoiceGamePage";
import OneWordStoryGamePage from "./pages/games/oneWordStory/OneWordStoryGamePage";
import {
  CONDUCTED_STORY_GAME, CONFESSIONS_GAME,
  INTERESTING_DISCUSSION_GAME,
  INTERVIEW_GAME,
  LINES_GAME, ONE_VOICE_GAME, ONE_WORD_STORY_GAME,
  PRESENTATION_GAME, QUESTIONS_GAME
} from "./common/utils/games";
import {AmplitudeEvent, initAmplitude, logEvent} from "./common/utils/amplitude";
import React, {useEffect} from "react";
import {preloadPlayers} from "./redux/playersSlice";
import {useDispatch} from "react-redux";

const App = () => {
  initAmplitude();

  const location = useLocation();
  useEffect(() => {
    logEvent(AmplitudeEvent.PAGE_VIEW);
  }, [location]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(preloadPlayers());
  }, [dispatch]);

  return (
    <div className="App"  >
      <Routes>
        <Route path='/' element={<HomePage/>} />
        <Route path='/history' element={<ImprovHistoryPage/>} />
        <Route path='/games' element={<GamesListPage/>} />
        <Route path={`/games/${PRESENTATION_GAME.name}`} element={<PresentationGame />} />
        <Route path={`/games/${INTERVIEW_GAME.name}`} element={<InterviewGamePage/>}/>
        <Route path={`/games/${CONDUCTED_STORY_GAME.name}`} element={<ConductedStoryGamePage/>} />
        <Route path={`/games/${INTERESTING_DISCUSSION_GAME.name}`} element={<InterestingDiscussionGamePage/>} />
        <Route path={`/games/${LINES_GAME.name}`} element={<LinesGamePage/>} />
        <Route path={`/games/${LINES_GAME.name}/:gameId/submit`} element={<LineSubmitPage/>} />
        <Route path={`/games/${LINES_GAME.name}/:gameId/admin`} element={<LinesAdminPage/>} />
        <Route path={`/games/${QUESTIONS_GAME.name}`} element={<QuestionsGamePage/>} />
        <Route path={`/games/${ONE_WORD_STORY_GAME.name}`} element={<OneWordStoryGamePage/>} />
        <Route path={`/games/${CONFESSIONS_GAME.name}`} element={<ConfessionGamePage/>} />
        <Route path={`/games/${ONE_VOICE_GAME.name}`} element={<OneVoiceGamePage/>} />
      </Routes>
    </div>
  );
};

export default App;
